import React, { useState, Fragment, useEffect } from "react";
import qs from "qs";
import { Grid, Box, FieldText, P } from "@saladbob/sassafras";

import CourtCard from "../cards/CourtCard";

import Host from '../../types/Host';
import { CourtDepth } from '../../types/Court';

type Props = {
    host: Host,
    bracketId: string,
    courts?: CourtDepth[],
};

const CourtListing: React.FC<Props> = ({ bracketId, courts: crts = [] }) => {
    const [search, setSearch] = useState('');
    const [courts, setCourts] = useState<CourtDepth[]>(crts);

    useEffect(() => {
        setCourts(crts);
    }, [crts]);

    const getCourts = async (e) => {
        const value = e.target.value;
        const normalized = value.trim();

        if (normalized.length === 0) {
            setSearch('');
            setCourts(crts);
            return;
        }

        if (normalized.length < 3) return;

        setSearch(value);
        const query = qs.stringify({ name: normalized });
        const response = await fetch(
            `${process.env.NEXT_PUBLIC_API_URL}/bracket/${bracketId}/find-courts?${query}`
        );
        const newCourts = await response.json();
        const docs = (newCourts.docs || []).map((court) => ({
            ...court,
            players: (court.players || []).filter((player) => (
                player.name.toLowerCase().includes(normalized.toLowerCase())
                || player.team.toLowerCase().includes(normalized.toLowerCase())
            )),
        }));

        setCourts(docs);
    };

    return (
        <Box padding={{ phone: 'md', laptop: 'lg' }} minHeight="100vh">
            <Box mb="md">
                <FieldText placeholder="Search By Team Name or Player Name" onInput={getCourts} />
            </Box>
            <Grid columns={
                search ? '1fr' : 'repeat(auto-fill, minMax(200px, 1fr))'
            } gridGap="sm">
                {courts.map(court => {
                    if (court.players) {
                        return (
                            <Grid
                                key={court.id}
                                columns={{ phone: 'max-content 1fr', desktop: 'minMax(max-content, 300px) 1fr' }}
                                gridGap="md"
                                bdWidth="0 0 1px 0"
                                bdColor="neutral200"
                                pb="md"
                            >
                                <CourtCard key={court.id} court={court} />
                                <div>
                                    <Grid columns="max-content 1fr" columnGap="sm" rows="min-content" pt="md" pb="md">
                                        <P mb="0" uppercase color="neutral">
                                            Player
                                        </P>
                                        <P mb="0" uppercase color="neutral">
                                            Team
                                        </P>
                                        {court.players.map(player => (
                                            <Fragment key={player.team}>
                                                <P mb="0" weight="bold" >{player.name}</P>
                                                <P mb="0" weight="bold" >{player.team}</P>
                                            </Fragment>
                                        ))}
                                    </Grid>
                                </div>
                            </Grid>
                        )
                    }
                    return <CourtCard key={court.id} court={court} />
                })}
            </Grid>
        </Box>
    );
};

export default CourtListing;
